import api from './axiosConfig';



export const fetchQuote = async (data) => {
  try {
    // Transform nested frontend payload to flat format expected by backend CodeIgniter /api/quote
    const formattedData = {
      ...data,
      start: data.start || data.pickup?.address || '',
      start_lat: data.start_lat ?? data.pickup?.coordinates?.lat ?? 0,
      start_lng: data.start_lng ?? data.pickup?.coordinates?.lng ?? 0,
      end: data.end || data.dropoff?.address || '',
      end_lat: data.end_lat ?? data.dropoff?.coordinates?.lat ?? 0,
      end_lng: data.end_lng ?? data.dropoff?.coordinates?.lng ?? 0,
      pick_date: data.pick_date || data.date || '',
      pick_time: data.pick_time || data.time || '',
      passengers: data.passengers ?? data.passenger ?? 1,
      luggage: data.luggage ?? 0,
      infant_seat: Number(data.infant_seat ?? data.infant ?? 0),
      regular_seat: Number(data.regular_seat ?? data.regular ?? 0),
      booster_seat: Number(data.booster_seat ?? data.booster ?? 0),
      domain_id: data.domain_id || 99
    };

    console.log("API Request (Formatted):", JSON.stringify(formattedData, null, 2));
    const response = await api.post("/api/quote", formattedData);
    return response.data; 
  } catch (error) {
    console.error("API Error Status:", error.response?.status);
    console.error("API Error Data:", error.response?.data);
    console.error("API Error Details:", JSON.stringify(error.response?.data, null, 2));
    console.error("Request Data:", JSON.stringify(data, null, 2));
    throw error; 
  }
};

export const bookingInfo = async (data) => {
  const start = Date.now();
  try {
    console.log('[API] Sending booking-info request with data:', data);
    const response = await api.post("/api/quote/booking-info", data);
    const end = Date.now();
    console.log(`[API] /api/quote/booking-info response time: ${end - start} ms`);
    console.log('[API] booking-info response:', response.data);
    return response.data; 
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /api/quote/booking-info response time (error): ${end - start} ms`);
    console.error("Error fetching data:", error);
    console.error("Request data that failed:", data);
    console.error("Error response:", error.response?.data);
    throw error; 
  }
};

export const fetchFareBreakdown = async (data) => {
  const start = Date.now();
  try {
    console.log('[API] Sending fare-breakdown request with data:', data);
    const response = await api.post("/api/quote/fare-breakdown", data);
    const end = Date.now();
    console.log(`[API] /api/quote/fare-breakdown response time: ${end - start} ms`);
    console.log('[API] fare-breakdown response:', response.data);
    return response.data; 
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /api/quote/fare-breakdown response time (error): ${end - start} ms`);
    console.error("Error fetching fare breakdown:", error);
    console.error("Request data that failed:", data);
    console.error("Error response:", error.response?.data);
    throw error; 
  }
};

export const confirmBooking = async (data) => {
  const start = Date.now();
  try {
    const response = await api.post("/api/quote/confirm", data);
    const end = Date.now();
    console.log(`[API] /api/quote/confirm response time: ${end - start} ms`);
    return response.data; 
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /api/quote/confirm response time (error): ${end - start} ms`);
    console.error("Error fetching data:", error);
    throw error; 
  }
};

export const finishBooking = async (data) => {
  const start = Date.now();
  try {
    console.log('[API] Sending finish booking request with data:', JSON.stringify(data, null, 2));
    const response = await api.post("/api/quote/finish", data);
    const end = Date.now();
    console.log(`[API] /api/quote/finish response time: ${end - start} ms`);
    console.log('[API] Finish booking response:', response.data);
    return response.data; 
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /api/quote/finish response time (error): ${end - start} ms`);
    console.error("Error fetching data:", error);
    console.log('[API] Request data that failed:', JSON.stringify(data, null, 2));
    if (error.response) {
      console.log('[API] Error response status:', error.response.status);
      console.log('[API] Error response data:', error.response.data);
      console.log('[API] Error response headers:', error.response.headers);
    }
    throw error; 
  }
};

export const createBooking = async (data) => {
  const start = Date.now();
  try {
    console.log('[API] Sending booking creation request with data:', JSON.stringify(data, null, 2));
    const response = await api.post("/api/booking/create", data);
    const end = Date.now();
    console.log(`[API] /api/booking/create response time: ${end - start} ms`);
    console.log('[API] Booking creation response:', response.data);
    return response.data; 
  } catch (error) {
    const end = Date.now();
    console.log(`[API] /api/booking/create response time (error): ${end - start} ms`);
    console.error("Error creating booking:", error);
    console.log('[API] Request data that failed:', JSON.stringify(data, null, 2));
    if (error.response) {
      console.log('[API] Error response status:', error.response.status);
      console.log('[API] Error response data:', error.response.data);
    }
    throw error; 
  }
};
